module.exports = "/static/img/mysql.svg?e4af89fa5993322d0d3760d4b50f6c95";